<template>
    <div>
        <v-img :src="helpImg.image" width="391" height="220"></v-img>
        <span v-html="helpImg.description" class="d-flex justify-center py-3"></span>
    </div>
</template>

<script>
export default {
    name: 'HelpImage',
    props: {
        helpImg: {
            type: Object,
            required: true
        }
    }
};
</script>


// WEBPACK FOOTER //
// src/components/myHabiteoStudio/steps/components/HelpImage.vue